@import '@hevoio/hevo-ui-toolkit/styles/variables';

.item {
  display: flex;
  align-items: center;
  .text {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    label {
      cursor: pointer;
    }

    &.disabled,
    &.disabled label {
      cursor: not-allowed;
    }
  }

  &.item + .item {
    margin-top: $spacer * 1.5;
  }
}
